import { DataVisualizationType } from "components/charting/config/chartTypes";
import ProfilingComparisonContext from "components/charting/contexts/ProfilingComparisonContext";
import useDataVisualizationType from "components/charting/hooks/useDataVisualizationType";
import { ProfilingChartEntityId } from "components/charting/types";
import useColorRegistry from "features/Charting/hooks/useColorRegistry";
import { useContext, useMemo } from "react";

function useLineDotColor(entityId: string) {
  // A single flag, so dots don't re-render on every set or profile selection change.
  const isProfilingComparisonChart = useContext(ProfilingComparisonContext);
  const visType = useDataVisualizationType();
  const getColor = useColorRegistry();

  const color = useMemo(() => {
    const isProfilingChart = visType === DataVisualizationType.PROFILING_CHART;

    if (!isProfilingChart) {
      return getColor(entityId);
    }

    if (!isProfilingComparisonChart) {
      return getColor(
        entityId
          .replace(`${ProfilingChartEntityId.PROFILING_LINE}-`, "")
          .replace(`${ProfilingChartEntityId.COMPARATIVE_LINE}-`, "")
      );
    }

    const modifiedEntityId =
      entityId.indexOf(ProfilingChartEntityId.PROFILING_LINE) > -1
        ? ProfilingChartEntityId.PROFILING_LINE
        : ProfilingChartEntityId.COMPARATIVE_LINE;

    return getColor(modifiedEntityId);
  }, [entityId, getColor, isProfilingComparisonChart, visType]);

  return color;
}

export default useLineDotColor;
